import React from "react";
import { CTASection } from "../../types/optimizely/blocks";
import { getColorClasses, getTextColorClass } from "../../utils/getBackgroundColor";
import classNames from "classnames";
import Link from "../Link/Link";

interface DoubleCTAProps {
  ctaLeft: CTASection;
  ctaRight: CTASection;
}

const CTADoubleBlock = ({ ctaLeft, ctaRight }: DoubleCTAProps) => {
  const {
    image: { value: { url: backgroundImage1 } = {} },
    heading: { value: leftTitle },
    introduction: { value: leftDescription },
    buttonLink: { value: leftButtonLink },
  } = ctaLeft;

  const {
    image: { value: { url: backgroundImage2 } = {} },
    heading: { value: rightTitle },
    introduction: { value: rightDescription },
    buttonLink: { value: rightButtonLink },
  } = ctaRight;

  const leftBackground = getColorClasses(ctaLeft?.backgroundColor?.value);
  const leftTextColor = getTextColorClass(ctaLeft?.backgroundColor?.value);
  const rightBackground = getColorClasses(ctaRight?.backgroundColor?.value);
  const rightTextColor = getTextColorClass(ctaRight?.backgroundColor?.value);

  const containerClasses = "container flex flex-col lg:flex-row min-h-[570px]";
  const blockClasses =
    "px-10 pt-11 pb-14 md:pb-10 min-h-[494px] md:max-h-[434px] flex-1 flex flex-col justify-between bg-cover bg-no-repeat bg-center";

  return (
    <section className="w-full pt-28">
      <div className={containerClasses}>
        <div
          className={classNames(
            blockClasses,
            leftBackground,
            "rounded-t-md lg:rounded-l-md lg:rounded-tr-none"
          )}
          style={
            backgroundImage1
              ? {
                  backgroundImage: `url(${backgroundImage1})`,
                  backgroundSize: "auto",
                }
              : {}
          }
        >
          <div>
            <p>{leftDescription}</p>
            <h2 className={classNames("text-4xl leading-tight font-medium mt-3", leftTextColor)}>
              {leftTitle}
            </h2>
          </div>
          <Link
            className="w-1/2 xl:w-1/3 text-nowrap min-w-40"
            text="Read more"
            variant="link-primary-reverse"
            href={leftButtonLink}
          />
        </div>
        <div
          className={classNames(
            blockClasses,
            rightBackground,
            "rounded-b-md lg:rounded-r-md lg:rounded-l-none"
          )}
          style={
            backgroundImage2
              ? {
                  backgroundImage: `url(${backgroundImage2})`,
                  backgroundSize: "auto",
                }
              : {}
          }
        >
          <div>
            <p>{rightDescription}</p>
            <h2 className={classNames("text-4xl leading-tight font-medium mt-3", rightTextColor)}>
              {rightTitle}
            </h2>
          </div>
          <Link
            className="w-1/2 xl:w-1/3 text-nowrap min-w-40"
            text="Read more"
            variant="link-primary"
            href={rightButtonLink}
          />
        </div>
      </div>
    </section>
  );
};

export default CTADoubleBlock;
